import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginSchema } from '@shared/schemas';
import { authUtils } from '@/hooks/useAuth';
import { useAuth } from '@/hooks/useAuth';
import { Link } from 'react-router-dom';

export function LoginPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return <div className="max-w-md mx-auto py-16"><p className="text-text-secondary">Laden...</p></div>;
  }

  if (user) {
    navigate('/dashboard');
    return null;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);

    const validation = loginSchema.safeParse({ email, password });
    if (!validation.success) {
      setError(validation.error.errors[0].message);
      return;
    }

    setSubmitting(true);
    try {
      await authUtils.login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('E-Mail oder Passwort ist falsch.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Anmelden</h1>

      {error && (
        <div className="mb-4 p-3 bg-status-danger/10 border border-status-danger/20 text-status-danger text-sm rounded-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-1">E-Mail</label>
          <input
            id="email"
            type="email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-1">Passwort</label>
          <input
            id="password"
            type="password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <div className="flex items-center justify-between">
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
          <Link to="/passwort-vergessen" className="text-sm text-text-secondary">
            Passwort vergessen?
          </Link>
        </div>
      </form>

      <p className="mt-6 text-sm text-text-secondary">
        Noch kein Zugang?{' '}
        <Link to="/registrieren" className="">Registrieren</Link>
      </p>
    </div>
  );
}
